module.exports = __webpack_public_path__ + "img/__Header_Desktop_Logo.ee601b36.png";